import { AnyAction } from 'redux';
import { AktionsNachlass } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '@ps20-frontend/apps/toolbar-store';

export const aktionsNachlassReducer = function (
  sectionState: AktionsNachlass = null,
  action: AnyAction,
  state: IAppState,
): AktionsNachlass {
  switch (action.type) {
    case GlobalActions.UPDATE_AKTIONSNACHLASS_CODE: {
      return action.payload;
    }
    case GlobalActions.CHECK_VALID_AKTIONSNACHLASS_CODE: {
      const foundKooperation = state.transientState.kooperationen?.some(
        k => k?.code === sectionState?.code,
      );
      if (!foundKooperation) {
        return {
          ...sectionState,
          code: null,
          name: null,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
